import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

export const casNumberField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'CAS number',
    context: 'Chemical Abstracts Service registry number.',
  }),
  externalDescription: msg({
    message: 'Chemical Abstracts Service registry number.',
    context: 'CAS number',
  }),
};

export const hazardClassField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Hazard class',
    context: 'The hazard class of the substance.',
  }),
};

export const substanceOfConcernField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Substance of concern',
    context: 'The substance of concern.',
  }),
};

export const euPrtrGroupField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'EU Pollutant Release and Transfer Register group',
    context: 'The display name for a dimension',
  }),
  externalDescription: msg({
    message:
      'European Pollutant Release and Transfer Register group of the substance.',
    context: 'EU Pollutant Release and Transfer Register group',
  }),
};
